/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_Open_ClientInputs */

const cs_matches_open_client = /** @type {(inputs: Matches_Open_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít klienta`)
};

const en_matches_open_client = /** @type {(inputs: Matches_Open_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open client`)
};

/**
* | output |
* | --- |
* | "Open client" |
*
* @param {Matches_Open_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_open_client = /** @type {((inputs?: Matches_Open_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_Open_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_open_client(inputs)
	return cs_matches_open_client(inputs)
});